import { HANDLE_PROMPT_ON_CLOSE_FOR_ADD_SECTIONDATA_BY_MODAL, SHOW_TAB_CLOSE_MODAL } from "../constants";


export const showTabCloseModal = (confirmTabCloseModal) => {
	return {
		type: SHOW_TAB_CLOSE_MODAL,
		confirmTabCloseModal: confirmTabCloseModal
	}
};

export const handlePromptOnCloseForModal = (promptOnClose) => {
	return {
		type: HANDLE_PROMPT_ON_CLOSE_FOR_ADD_SECTIONDATA_BY_MODAL,
		data: promptOnClose
	}
};